import styles from './ConfidenceMeter.module.css';

type ConfidenceMeterProps = Readonly<{
  value: number;
  label?: string;
}>;

const ConfidenceMeter = ({ value, label }: ConfidenceMeterProps): React.ReactElement => {
  const fillPct = `${(value / 5) * 100}%`;
  const hasFill = value > 0;

  return (
    <div className={styles.container} data-testid="confidence-meter">
      {label != null && (
        <div className={styles.label} data-testid="confidence-label">
          {label}
        </div>
      )}
      <div className={styles.barTrack}>
        <div
          className={`${styles.barFill}${hasFill ? ` ${styles.pulse}` : ''}`}
          style={{ '--fill-pct': fillPct } as React.CSSProperties}
          data-testid="confidence-fill"
        />
      </div>
      <div className={styles.value} data-testid="confidence-value">
        {value.toFixed(1)} / 5.0
      </div>
    </div>
  );
};

export { ConfidenceMeter };
export type { ConfidenceMeterProps };
